import styled from 'styled-components';
import { rem } from 'polished';
import AvatarPerson from '../../../core/AvatarPerson';

const StyledChat = styled.div`
  width: auto;
  .chat-content {
    width: 100%;
    min-height: ${rem('389px')};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .chat-lister {
    width: 100%;
    min-height: ${rem('389px')};
    display: flex;
    overflow: hidden;
  }
  .title {
    color: ${props => props.theme.colors.light};
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('17px')};
    text-transform: uppercase;
    margin-top: ${rem('5px')};
    margin-bottom: ${rem('20px')};
    line-height: ${rem('20px')};
    display: flex;
    align-items: center;
  }
  .icon-title {
    width: ${rem('17px')};
    fill: ${props => props.theme.colors.light};
    margin-right: ${rem('7px')};
  }
  .chat-sub-title {
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${rem('14px')};
    color: ${props => props.theme.colors.light};
    margin-bottom: 0;
  }
  .chat-list {
    width: 100%;
    border-top: ${rem('2px')} ${props => props.theme.colors.primary} solid;
    margin: 0 0 ${rem('15px')} 0;
    padding: 0;
  }
  .chat-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    background-color: rgba(255, 255, 255, 0.92);
    padding: ${rem('12px')} ${rem('12px')} ${rem('12px')} ${rem('10px')};
    margin-bottom: ${rem('2px')};
    &:before {
      content: none;
    }
  }
  .chat-wrapper-msj {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: ${rem('52px')};
    position: relative;
  }

  .chat-name {
    font-size: ${rem('14px')};
    line-height: ${rem('14px')};
    color: ${props => props.theme.colors.gray};
    margin: 0 0 ${rem('4px')} 0;
  }
  .chat-msj,
  .chat-msj-txt {
    display: flex;
    font-size: ${rem('14px')};
    line-height: ${rem('14px')};
    color: ${props => props.theme.colors.grayDarkest};
    margin: 0;
  }
  .chat-msj {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-indent: -9999px;
    overflow: hidden;
    z-index: 2;
    &:hover + .chat-animation {
      transform: translateX(0);
    }
  }
  .chat-animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.colors.primary};
    z-index: 3;
    text-align: center;
    transition: 0.5s;
    transform: translateX(100%);
    pointer-events: auto;
    &:hover {
      transform: translateX(0);
    }
  }
  .chat-msj-animation {
    display: inline-block;
    font-family: ${props => props.theme.fonts.bold};
    font-size: ${rem('12px')};
    line-height: ${rem('12px')};
    color: ${props => props.theme.colors.light};
    text-transform: uppercase;
    border: ${rem('2px')} ${props => props.theme.colors.light} solid;
    padding: ${rem('8px')} ${rem('20px')};
    margin: ${rem('21px')} auto 0 auto;
    transition: 0.5s;
    &:hover {
      background-color: ${props => props.theme.colors.light};
      color: ${props => props.theme.colors.primary};
    }
  }
  .chat-msj-txt {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: ${rem('18px')};
  }
  .chat-time {
    position: absolute;
    top: 13px;
    right: 15px;
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('14px')};
    line-height: ${rem('14px')};
    color: ${props => props.theme.colors.gray};
  }
  .chat-link-init {
    display: block;
    margin: 0 auto;
    width: ${rem('198px')};

    &.chat-link-init--find {
      width: 90px;
    }
  }
  .chat-btn-init {
    font-size: ${rem('12px')};
    margin: 0 auto ${rem('15px')} 0;
  }
  /* init conversation */
  .chat-wrapper-contact {
    position: relative;
  }
  .chat-autocomplete {
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('14px')};
    line-height: ${rem('14px')};
    color: ${props => props.theme.colors.gray};
    margin: ${rem('8px')} 0 ${rem('15px')} 0;
    padding: ${rem('14px')} ${rem('10px')};
    width: 100%;
  }
  .chat-contact-list {
    top: ${rem('49px')};
    left: 0;
    width: 100%;
    background-color: ${props => props.theme.colors.light};
    margin: 0;
    padding: 0;
    max-height: ${rem('300px')};
    overflow-y: auto;
  }

  .chat-contact {
    display: flex;
    align-items: center;
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('12px')};
    padding-left: 0;
    > button {
      background: transparent;
      border: 0;
      width: 100%;
      display: flex;
      text-align: left;
      align-content: center;
      justify-content: space-around;
    }
    &:before {
      content: none;
    }
    &:hover {
      background-color: ${props => props.theme.colors.grayLightest};
    }
  }
  .chat-contact-link {
    display: block;
    padding: ${rem('10px')} 0 ${rem('10px')} ${rem('10px')};
    color: ${props => props.theme.colors.dark};

    &.chat-contact-link--text {
      width: 100%;
      padding: 0.625rem 0;
      height: 56px;
      align-content: center;
      display: flex;
      flex-flow: column;
      justify-content: space-around;
    }
  }
  .multiplePils {
    font-family: 'Montserrat Regular', Helvetica, Arial, sans-serif;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    background-color: white;
    > input {
      font-size: 0.875rem;
      line-height: 0.875rem;
      color: #898989;
      margin: 0.5rem 0 0.9375rem 0;
      padding: 0.875rem 0.625rem;
      border: 0;
      flex-grow: 1;
    }
    .pil {
      background: #e7e7e7;
      margin: 5px;
      display: flex;
      align-items: center;
      padding: 0 10px;
    }
  }
`;

const StyledAvatarPerson = styled(AvatarPerson)`
  font-size: 100%;
  border: none;
  background-color: ${props => props.theme.colors.grayLight};
  width: ${rem('36px')};
  height: ${rem('36px')};
  min-width: ${rem('36px')};
  margin-right: ${rem('10px')};
  margin-left: 300px;
  position: absolute;
  display: flex;

  .avatar-char {
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${rem('12px')};
    color: ${props => props.theme.colors.dark};
  }
`;

const StyledLabelButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Montserrat Medium', Helvetica, Arial, sans-serif;
  margin: 20px 0 10px 0;
  > span {
    font-size: 0.875rem;
    color: #ffffff;
  }
  > button {
    border: 0;
    font-size: 0.75rem;
    font-size: 0.875rem;
    color: #ffffff;
    text-transform: uppercase;
    padding: 0.425rem 0.55rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    background-color: #f95752;
    margin: 0;
    > a {
      color: #ffffff;
    }
  }
`;

export { StyledChat, StyledAvatarPerson, StyledLabelButton };
